<template>
<div id="consultadiaria" >
  <div>
    <v-breadcrumbs :items="breadcrumbs" >
      <v-icon slot="divider" >forward</v-icon>
    </v-breadcrumbs>
  </div>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12>
        <base-material-card color="primary" icon="library_books" title="Consulta Diaria de Pedimentos" class="elevation-1 px-5 py-3" >
          <v-card-actions>

            <v-spacer></v-spacer>
            <exportar-excel :data="reporte_errores.items" :exportFields="reporte_errores.camposexcel" name="ConsultaDiaria.xlsx" v-if="is_loaded" >
              <v-btn fab dark x-small color="success" title="Exportar" v-tippy>
                <v-icon dark>get_app</v-icon>
              </v-btn>
            </exportar-excel>
            <v-btn fab dark x-small color="secondary" slot="activator" @click.native="openModal()" title="Agregar Registro" v-tippy>
              <v-icon dark>add</v-icon>
            </v-btn>

            <v-dialog v-model="modal" max-width="60%" style=" z-index: 400 !important;" >
              <v-card>
                <v-card-title>
                  <v-card class="primary white--text titulomodal" >
                    <v-icon class="white--text" >add</v-icon>&nbsp;
                    <span class="subheading" >
                      <strong>Nueva Consulta Diaria</strong>
                    </span>
                  </v-card>
                  <v-spacer></v-spacer>
                  <v-btn icon @click.native="modal = false" class="close_modal" >
                    <v-icon class="white--text" >cancel</v-icon>
                  </v-btn>
                </v-card-title>
                <v-form ref="form" lazy-validation>
                  <v-card-text>
                    <v-container grid-list-md text-xs-center @keyup.enter="guardar()" >
                      <v-layout row wrap>
                        <v-flex s12 m6 l6>
                          <v-menu offset-x ref="menu1" :close-on-content-click="false" v-model="menu1" :nudge-right="40" transition="scale-transition" offset-y max-width="290px" min-width="290px" >
                            <template v-slot:activator="{ on }" >
                              <v-text-field v-on="on" v-model="model.fecha_inicial" label="Fecha Inicial" prepend-icon="event" @blur="model.fecha_inicial = parseDate(model.fecha_inicial)" v-mask="'####-##-##'"
                                  :rules="[rules.required, verificarFecha(model.fecha_inicial), verificarRangoFechas(), verificaGlosa(model.fecha_inicial)]" ></v-text-field>
                            </template>
                            <v-date-picker v-model="model.fecha_inicial" no-title @input="menu1 = false; model.fecha_final = parseDate(model.fecha_inicial)" locale="es-mx" ></v-date-picker>
                          </v-menu>
                        </v-flex>
                        <v-flex s12 m6 l6>
                          <v-menu offset-x ref="menu2" :close-on-content-click="false" v-model="menu2" :nudge-right="40" transition="scale-transition" offset-y max-width="290px" min-width="290px" >
                            <template v-slot:activator="{ on }" >
                              <v-text-field v-on="on" v-model="model.fecha_final" label="Fecha Final" prepend-icon="event" @blur="model.fecha_final = parseDate(model.fecha_final)" v-mask="'####-##-##'"
                                  :rules="[rules.required, verificarFecha(model.fecha_final), verificarRangoFechas(), verificarFechaFinal(), verificaGlosa(model.fecha_final)]" ></v-text-field>
                            </template>
                            <v-date-picker v-model="model.fecha_final" no-title @input="menu2 = false" locale="es-mx" ></v-date-picker>

                          </v-menu>
                        </v-flex>
                      </v-layout>

                    </v-container>
                  </v-card-text>
                </v-form>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn@click.native="modal=false" >
                    <v-icon>cancel</v-icon> Cancelar</v-btn>
                    <v-btn color="success" :loading="loading" @click.native="guardar()" >
                      <v-icon>done</v-icon>Guardar
                    </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

          </v-card-actions>

          <v-card-text>
            <div id="datagrid" >

              <v-client-table ref="principalTable" :data="registros.items" :columns="columns" :options="options" class="elevation-2 pa-2" >
                <template slot="noResults" >
                  <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                </template>

                <template slot="detail" slot-scope="props" >
                  <v-btn icon color="primary" title="Mostrar Pedimentos" @click="showDetail(props.row)" >
                    <v-icon v-if="registro_seleccionado != props.row.id" >add_circle</v-icon>
                    <v-icon v-if="registro_seleccionado == props.row.id" >remove_circle</v-icon>
                  </v-btn>
                </template>

                <template slot="actions" slot-scope="props" >
                  <v-speed-dial :id="props.row.id" direction="left" open-on-hover>
                    <template v-slot:activator>
                      <v-btn :id="props.row.id" x-small fab dark color="primary" >
                        <v-icon>reorder</v-icon>
                      </v-btn>
                    </template>

                    <v-btn x-small fab dark color="blue" v-if="props.row.estatus=='Procesado'" @click.native="revalidar(props.row.id)" title="Revalidar Pedimentos" v-tippy>
                      <v-icon>replay</v-icon>
                    </v-btn>
                    <v-btn x-small fab dark color="orange" v-if="props.row.estatus=='Procesado'" @click.native="reintentar(props.row.id)" title="Volver a Recuperar" v-tippy>
                      <v-icon>info</v-icon>
                    </v-btn>
                    <v-btn x-small fab dark color="pink" @click.native="
                          deleteRegistro(props.row.id)
                        " title="Eliminar Registro" v-tippy>
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-speed-dial>
                </template>

                <template slot="child_row" >
                  <v-toolbar dense height="35pt" >
                    <v-toolbar-title><span style="font-size:12pt" >Registros del periodo:</span></v-toolbar-title>
                  </v-toolbar>
                  <v-card-text>
                    <div class="row" >
                      <v-spacer></v-spacer>
                      <div class="col-xs-1" >
                        <exportar-excel :data="datafiltered" :exportFields="dias.camposexcel" name="ConsultaDiaria.xlsx" >
                          <v-btn fab dark small color="success" title="Exportar" v-tippy>
                            <v-icon dark>get_app</v-icon>
                          </v-btn>
                        </exportar-excel>

                      </div>
                    </div>
                    <div class="row" >
                      <div class="col-xs-10" ></div>
                    </div>
                    <v-client-table ref="vuetable" :data="dias.items" :columns="columnsDias" :options="optionsDias" class="elevation-2 pa-2" >
                      <template slot="noResults" >
                        <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                      </template>
                    </v-client-table>
                  </v-card-text>
                  <hr>

                </template>

              </v-client-table>
            </div>
           
          </v-card-text>
        </base-material-card>
      </v-flex>
    </v-layout>
  </v-container>

</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import ComboPaises from '@/components/ComboPaises/index.vue';
import {
  Promise
} from 'q';

export default {
  components: {
    "v-combo-paises": ComboPaises,
  },

  data: () => ({
    is_loaded: false,
    fab: false,
    menu1: false,
    menu2: false,
    name: "datagrid",
    importData: [],
    calendario: [],
    columns: [
      "detail",
      "fecha_solicitud",
      "fecha_inicial",
      "fecha_final",
      "estatus",
      "actions"
    ],
    options: {
      filterable: [
        "fecha_solicitud",
        "fecha_inicial",
        "fecha_final",
        "estatus",
      ],
      sortable: [
        "fecha_solicitud",
        "fecha_inicial",
        "fecha_final",
        "estatus",
      ],

      headings: {
        detail: '',
        fecha_solicitud: "Fecha Solicitud",
        fecha_inicial: "Fecha Inicial",
        fecha_final: "Fecha Final",
        estatus: "Estatus",
        actions: "Operaciones",
      },
      uniqueKey: "id",
    },
    URL: "",
    show_loading: true,
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/home"
      },
      {
        text: "Vucem-Pedimento",
        disabled: true,
        to: ""
      },
      {
        text: "Consulta diaria",
        disabled: true,
        to: ""
      }
    ],
    loading: false,
    title: "",
    modal: false,
    model: {
      rfc: "",
      fecha_inicial: "",
      fecha_final: "",
      usuario: "",
    },
    rules: {
      required: v => !!v || "Este campo es requerido",
    },

    registros: {
      selected: [],
      items: [0],
    },
    //DOMICILIOS
    dias: {
      items: [],
      camposexcel: {
        "Fecha": "fecha",
        "Pedimento": "pedimento",
        "Estatus recuperación": "estatus",
        "Respuesta-Error": "error",
      },
    },
    columnsDias: [
      "fecha",
      "pedimento",
      "estatus",
      "error",
    ],
    optionsDias: {
      filterable: [
        "fecha",
        "pedimento",
        "estatus",
        "error",
      ],
      sortable: [
        "fecha",
        "pedimento",
        "estatus",
        "error",
      ],
      headings: {
        fecha: "Fecha",
        pedimento: "Pedimento",
        estatus: "Estatus recuperación",
        "Respuesta/Error": "error",
      },
    },
    reporte_errores: {
      items: [],
      camposexcel: {
        "Fecha": "fecha",
        "Pedimento": "pedimento",
        "Estatus recuperación": "estatus",
        "Respuesta-Error": "error",
      },
    },

    registro_seleccionado: '',
  }),
  computed: {
    datafiltered() {
      if (this.$refs.vuetable != null) {
        return this.$refs.vuetable.allFilteredData;
      } else {
        return this.dias.items;
      }

    },
  },
  methods: {
    parseDate(date) {
      //Formato  YYYY-MM-DD
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },

    //Verifica sila fecha ya estrá dentro de un rango de fechas registrados anteriormente
    verificarFecha: function(fecha) {
      if (fecha != null && fecha.toString().trim() != '') {
        var d1 = new Date(fecha);
        
        var hoy = new Date();

        var search = this.registros.items.filter(function(e) {
          var registro1 = new Date(e.fecha_inicial);
          var registro2 = new Date(e.fecha_final);

          return ((d1 >= registro1 && d1 <= registro2));
        });
        var resultado = search.length > 0 ? 'La fecha ya se encuentra dentro del rango de fechas de un registro anterior.' : true;
        if (resultado === true) {
          return (d1 > hoy) ? "No debe ser mayor a la fecha actual." : true;
        } else
          return resultado;

      } else
        return true;
    },

    verificarFechaFinal: function() {
      if (this.model.fecha_inicial != null && this.model.fecha_inicial.toString().trim() != '' && this.model.fecha_final != null && this.model.fecha_final.toString().trim() != '') {
        var d1 = new Date(this.model.fecha_inicial);
        var d2 = new Date(this.model.fecha_final);

        var mayor = (d2 < d1) ? 'La fecha final no puede ser menor a la fecha inicial.' : true;
        if (mayor === true) {
          var fecha1 = moment(d1);
          var fecha2 = moment(d2);
          var diferencia = fecha2.diff(fecha1, 'days') + 1;
          if (diferencia > 31)
            return "El rango no debe ser mayor a 31 días.";
          else
            return true;
        } else
          return mayor;

      } else
        return true;
    },

    //Verifica si el rango de fechas seleccionado está incluyendo alguna fecha ya registrada anteriormente
    verificarRangoFechas: function() {
      if (this.model.fecha_inicial != null && this.model.fecha_inicial.toString().trim() != '' && this.model.fecha_final != null && this.model.fecha_final.toString().trim() != '') {
        var d1 = new Date(this.model.fecha_inicial);
        var d2 = new Date(this.model.fecha_final);

        var search = this.registros.items.filter(function(e) {
          var registro1 = new Date(e.fecha_inicial);
          var registro2 = new Date(e.fecha_final);
          return ((registro1 >= d1 && registro1 <= d2) || (registro2 >= d1 && registro1 <= d2));
        });
        return search.length > 0 ? 'Ya existen fechas registradas, que están dentro del rango seleccionado.' : true;
      } else
        return true;
    },
      verificaGlosa: function(fecha) {
      if (fecha != null && fecha.toString().trim() != '') {
       
       
        let y = fecha.substr(0,4);
        let m = parseInt(fecha.substr(5,2));
       
      if(this.calendario[y] != undefined && this.calendario[y][m] != undefined && this.calendario[y][m]  ){
          return 'Ya fue cargada las glosa de ese periodo.';
      }else {
        return true;
      }
        
      } else
        return true;
    },

    showDetail: function(row) {
      if (this.registro_seleccionado != row.id) {
        this.registro_seleccionado = row.id;
        this.cargarDias();
        var detallesAbiertos = this.$refs.principalTable.openChildRows;
        for (var k in detallesAbiertos) { //Cerramos detalles abiertos
          if (detallesAbiertos[k] != row.id)
            this.$refs.principalTable.toggleChildRow(detallesAbiertos[k]);
        }
      } else { //Significa que dio clic en '-' solo cerramos el detalle y no hacemos nada
        this.registro_seleccionado = '';
      }
      this.$refs.principalTable.toggleChildRow(row.id); //Mostramos detalle seleccionado

    },
    openModal: function() {
      this.limpiarModel();
      this.modal = true;
    },
    limpiarModel: function() {
      for (var k in this.model) {
        this.model[k] = "";
      }
      this.model.rfc = this.$local_storage.get("rfc");
      this.model.usuario = this.$local_storage.get("id_usuario");
    },

    guardar() {
      const datos = this.model;

      if (!this.$refs.form.validate()) {
        //Alguna operación o mensaje
      } else {
        this.loading = true;
        var metodo = "post";
        datos["origen"] = "Consulta Diaria";
        axios({
            method: metodo,
            url: this.URL + "save_consulta/",
            data: datos
          })
          .then(res => {
            this.$swal({
              type: "success",
              title: "¡Operación Exitosa!",
              text: "Los datos se guardaron correctamente. Espere en un lapso de 24 horas los resultados.",
              footer: ""
            });
          })
          .catch(error => {
            this.$swal({
              position: "center",
              type: "error",
              title: "¡Operación no Permitida!",
              text: "Ocurrió un error al guardar los datos. Comuníquese con el administrador del sistema."
              //showConfirmButton: false,
            });
            console.log(error);
          }).then(() => {
            this.cargar();
            this.loading = false;
            this.modal = false;
          });
      }
    },

    cargar: function() {
      var datos = {
        rfc: this.$local_storage.get("rfc")
      };
      axios
        .post(this.URL + "get_consultas/", datos)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.registros.items = res.data;
            for (var k in this.registros.items) {
              this.registros.items[k].fecha_solicitud = this.parseDate(this.registros.items[k].fecha_solicitud);
              this.registros.items[k].fecha_inicial = this.parseDate(this.registros.items[k].fecha_inicial);
              this.registros.items[k].fecha_final = this.parseDate(this.registros.items[k].fecha_final);
              this.registros.items[k].estatus = this.getEstatusConsulta(this.registros.items[k].estatus);
            }
            this.registros.items.sort(function(a, b) {
              //Ordenar por fecha más reciente
              return new Date(b.fecha_inicial) - new Date(a.fecha_inicial) ;
            });

            this.$root.$dialogLoader.hide();
          }
        })
        .catch(err => {
          console.log(err);
          //console.log(err);
          this.$root.$dialogLoader.hide();
        });
    },

    cargarDias: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        id: this.registro_seleccionado
      };
      axios
        .post(this.URL + "get_detalles/", datos)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.dias.items = res.data;
            for (var k in this.dias.items) {
              this.dias.items[k].fecha = this.parseDate(this.dias.items[k].fecha);
              this.dias.items[k].estatus = this.getEstatusDetalle(this.dias.items[k].estatus);
            }

            this.dias.items.sort(function(a, b) {
              //Ordenar por fecha más reciente
              return new Date(b.fecha) - new Date(a.fecha) ;
            });
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los dias.",
            footer: ""
          });
          console.log(err);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },

    deleteRegistro: function(id) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        id: id
      };
      axios
        .post(this.URL + "elimina_consulta/", datos)
        .then(res => {

          this.$swal({
            type: "success",
            title: "¡Operación Exitosa!",
            text: "El registro se eliminó correctamente.",
            footer: ""
          });

        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al eliminar el registro.",
            footer: ""
          });
          console.log(err);
        }).then(() => {
          this.cargar();
          this.$root.$dialogLoader.hide();
        });
    },

    revalidar: function(id) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        id: id
      };
      axios
        .post(this.URL + "revalidar/", datos)
        .then(res => {

          this.$swal({
            type: "success",
            title: "¡Operación Exitosa!",
            text: "El proceso se realizó correctamente.",
            footer: ""
          });

        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al revalidar los pedimentos.",
            footer: ""
          });
          console.log(err);
        }).then(() => {
          this.cargar();
          if (this.registro_seleccionado != '')
            this.cargarDias();
          this.$root.$dialogLoader.hide();
        });
    },

    reintentar: function(id) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        id: id,
        usuario: this.$local_storage.get("id_usuario"),
        origen:"Consulta Diaria"
      };
      axios
        .post(this.URL + "reintentar/", datos)
        .then(res => {

          this.$swal({
            type: "success",
            title: "¡Operación Exitosa!",
            text: "El proceso se encoló. Para ver los resultados debe revalidar más tarde.",
            footer: ""
          });

        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al revalidar los pedimentos.",
            footer: ""
          });
          console.log(err);
        }).then(() => {
          this.cargar();
          if (this.registro_seleccionado != '')
            this.cargarDias();
          this.$root.$dialogLoader.hide();
        });
    },

    getEstatusConsulta: function(estatus) {
      var arr_estatus = ["Pendiente", "Procesado"];
      if (estatus in arr_estatus)
        return arr_estatus[estatus];
      else
        return "N/A";
    },
    getEstatusDetalle: function(estatus) {
      var arr_estatus = ["Pendiente", "En cola", "Recuperado", "Con error", "No recuperable"];
      if (estatus in arr_estatus)
        return arr_estatus[estatus];
      else
        return "N/A";
    },
    load_reporte: function() {
      var datos = {
        rfc: this.$local_storage.get("rfc")
      };

      axios
        .post(this.URL + "reporte_errores/", datos)
        .then(res => {
          this.is_loaded = true;
          this.reporte_errores.items = res.data
        })
        .catch(err => {
          this.is_loaded = false;
        });
    },
    cargaGlosas: function (key) {
            var datos = {
                rfc: this.$local_storage.get("rfc"),
            }
            axios.post(this.$apiReportes + 'reportes/get_calendar/', datos)
                .then((response) => {
                    if (response.data.calendario) {
                       this.calendario = response.data.calendario;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },

  }, //methods
  created: function() {
    this.URL = this.$hostname + "consulta_diaria/";
    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
    this.load_reporte();
    this.cargar();
    this.cargaGlosas();
  }
};
</script>

<style scoped>
#consultadiaria>>>.VueTables__child-row-toggler {
  display: none;
}
</style>
